import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('viubux_token');
    if (!token) { setUser(false); return; }
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(data);
    } catch {
      localStorage.removeItem('viubux_token');
      setUser(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    // Store token from response cookie won't work cross-domain, use localStorage
    // The backend also returns the token in response for this purpose
    if (data.token) {
      localStorage.setItem('viubux_token', data.token);
    }
    setUser(data);
    return data;
  };

  const logout = async () => {
    localStorage.removeItem('viubux_token');
    try { await axios.post(`${API}/auth/logout`); } catch {}
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
